import { c as _c } from "react/compiler-runtime";
import { useMachine } from '@xstate/react';
import constate from 'constate';
import type { MachineContext } from '../../utils/state-machine';
import createNonIdDocMachine from '../../utils/state-machine/machine';
export type NonIdDocMachineArgs = {
  args: MachineContext;
};
const useLocalNonIdDocMachine = t0 => {
  const $ = _c(2);
  const {
    args
  } = t0;
  let t1;
  if ($[0] !== args) {
    t1 = () => createNonIdDocMachine(args);
    $[0] = args;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useMachine(t1);
};
export const [MachineProvider, useNonIdDocMachine] = constate(useLocalNonIdDocMachine);
export default MachineProvider;